












import { Component, Mixins } from "vue-property-decorator";
import { AbstractCheckableItem } from "../../../../domain/document/items";
import { ModelEditableMixin } from "../../../system/mixins";

@Component({
})
export default class MultiCheckEditor extends Mixins(ModelEditableMixin) {
  editingSource: AbstractCheckableItem;

  get isMultiCheckable(): boolean {
    return this.editingSource
      ? this.editingSource.isMultiCheckable
      : undefined;
  }

  set isMultiCheckable(value: boolean) {
    this.writeProperty(s => s.isMultiCheckable = value);
  }
}
